import i18n from 'app/i18n';
import _get from 'lodash/get';

export function errorMessageFromApiError(apiError, defaultMessage = i18n.t('pleaseReachOutToSupport')): string {
  const axiosMessage = _get(apiError, 'response.data.error');
  if (axiosMessage) {
    return axiosMessage;
  }
  if (typeof apiError?.data === 'string' && apiError.data) {
    return apiError.data;
  }
  return defaultMessage;
}
